module.exports = __webpack_public_path__ + "img/mapA.7d432bb0.png";